import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { showErrorToast } from "../../../fnx/showError";
export var useErrorHandling = function (_a) {
    var errorCalculate = _a.errorCalculate, errorComplete = _a.errorComplete, errorRegion = _a.errorRegion, setSeeToast = _a.setSeeToast, errorCatalogues = _a.errorCatalogues, setDisableNextButton = _a.setDisableNextButton;
    var t = useTranslation().t;
    useEffect(function () {
        if (errorCalculate) {
            showErrorToast(errorCalculate, setSeeToast, t);
            setDisableNextButton === null || setDisableNextButton === void 0 ? void 0 : setDisableNextButton(true);
        }
    }, [errorCalculate]);
    useEffect(function () {
        if (errorComplete) {
            showErrorToast(errorComplete, setSeeToast, t);
        }
    }, [errorComplete]);
    useEffect(function () {
        if (errorRegion) {
            showErrorToast(errorRegion, setSeeToast, t);
        }
    }, [errorRegion]);
    useEffect(function () {
        if (errorCatalogues) {
            showErrorToast(errorCatalogues, setSeeToast, t);
        }
    }, [errorCatalogues]);
};
